import { createStaticReducer } from '../../../utils/redux';
import { IConfigState } from './types';

export const config = createStaticReducer<IConfigState>({} as IConfigState);
